var $5bfd172db1a18268$exports = {};
$5bfd172db1a18268$exports = {
    "collectionLabel": `\u{5EFA}\u{8B70}`
};


export {$5bfd172db1a18268$exports as default};
//# sourceMappingURL=zh-TW.module.js.map
